import { ProductTypeEnum, type Security } from '@talos/kyoko';
import { MultilegComboType } from '../components/MultilegCombo/enums';

export interface MultilegOption {
  type: MultilegComboType;
  label: string;
}

/**
 * Determines which multileg types are available based on the security's ProductType.
 * Used by MarketDataCardMenu, SymbolActionsMenu and option chain context menu.
 */
export function getAvailableMultilegTypes(security: Security | undefined, enableCFD = false): MultilegOption[] {
  if (!security) {
    return [];
  }

  const { ProductType } = security;

  if (ProductType === ProductTypeEnum.CFD && !enableCFD) {
    return [];
  }

  switch (ProductType) {
    case ProductTypeEnum.Spot:
    case ProductTypeEnum.PerpetualSwap:
    case ProductTypeEnum.CFD:
      return [
        { type: MultilegComboType.Delta1Spread, label: 'Delta-1' },
        { type: MultilegComboType.SyntheticCross, label: 'Synthetic Cross' },
      ];

    case ProductTypeEnum.Future:
      return [{ type: MultilegComboType.Delta1Spread, label: 'Delta-1' }];

    case ProductTypeEnum.Option:
      return [
        { type: MultilegComboType.OptionsCalendarSpread, label: 'Calendar Spread' },
        { type: MultilegComboType.OptionsVerticalSpread, label: 'Vertical Spread' },
      ];

    default:
      return [];
  }
}
